export function uploadMenu(db, feed) {
	return new Promise((resolve, reject) => {
		db.doc()
			.set(feed)
			.then(() => {
				resolve("SUCCESS");
			})
			.catch((error) => reject(new Error("Ocurrio un error al subir el archivo")));
		return;
	});
}

export function updateMenu(db, feed, document) {
	return new Promise((resolve, reject) => {
		db.doc(document)
			.set(feed)
			.then(() => {
				resolve("SUCCESS");
			})
			.catch((error) => reject(new Error("Ocurrio un error al subir el archivo")));
		return;
	});
}

export function retrieveData(db, document) {
	return new Promise((resolve, reject) => {
		db.doc(document)
			.get()
			.then((doc) => {
				const data = doc.data();
				resolve(data);
			})
			.catch((error) => reject(new Error("Ocurrio un error al descargar el archivo")));
		return;
	});
}

export function deleteData(db, document) {
	return new Promise((resolve, reject) => {
		db.doc(document)
			.delete()
			.then(() => {
				resolve("SUCCESS");
			})
			.catch((error) => reject(new Error("Ocurrio un error al intentar eliminar el archivo")));
	});
}
